'use strict';

var ModifiersShape = require('../../../../_virtual/ModifiersShape.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var toConsumableArray = require('../../node_modules/@babel/runtime/helpers/toConsumableArray.js');
var PropTypes = require('prop-types');
var index = require('../../../airbnb-prop-types/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(defineProperty);

var _toConsumableArray2 = _interopRequireDefault(toConsumableArray);

var _propTypes = _interopRequireDefault(PropTypes__default["default"]);

var _airbnbPropTypes = index;

var _default = (0, _airbnbPropTypes.and)([_propTypes["default"].instanceOf(Set), function modifiers(props, propName) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  var propValue = props[propName];
  var firstError;
  (0, _toConsumableArray2["default"])(propValue).some(function (v, i) {
    var _PropTypes$string;

    var fakePropName = "".concat(propName, ": index ").concat(i);
    firstError = (_PropTypes$string = _propTypes["default"].string).isRequired.apply(_PropTypes$string, [(0, _defineProperty2["default"])({}, fakePropName, v), fakePropName].concat(rest));
    return firstError != null;
  });
  return firstError == null ? null : firstError;
}], 'Modifiers (Set of Strings)');

exports["default"] = _default;
}(ModifiersShape.__exports));
